import React, { useEffect } from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary.ts';
import { LoadableLazy } from '@confluence/loadable';

import type { SuggestionsFeedbackCollectorProps } from './SuggestionsFeedbackCollector.tsx';

const LoadingFeedback = ({
	error,
	onClose,
}: SuggestionsFeedbackCollectorProps & { error?: unknown }) => {
	useEffect(() => {
		if (error) {
			onClose();
		}
	}, [error, onClose]);
	return null;
};

const LazySuggestionsFeedbackCollector = LoadableLazy<SuggestionsFeedbackCollectorProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SuggestionsFeedbackCollector" */ './SuggestionsFeedbackCollector.tsx'
			)
		).SuggestionsFeedbackCollector,
	// Loadable reports import failures itself; this exposes them to the local close/reset handler.
	isReactLoadable: true,
	loading: LoadingFeedback,
});

export const SuggestionsFeedbackCollectorLoader = (
	props: SuggestionsFeedbackCollectorProps,
): React.JSX.Element => (
	<TransparentErrorBoundary attribution={Attribution.CC_EDITOR_AI} onError={props.onClose}>
		<LazySuggestionsFeedbackCollector {...props} />
	</TransparentErrorBoundary>
);
